import { ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from '../../styles.css';

export const socialPaymentsAccordions = {
  title: 'Социальные выплаты на погашение ипотеки',
  elements: [
    {
      title: 'Материнский капитал',
      content: (
        <ArticleParagraph2>
          С 2020 года сертификат можно получить уже после рождения первого ребёнка. Потратить средства маткапитала
          по-прежнему можно только на определенные цели, установленные государством. Одна из них — улучшение жилищных
          условий семьи. Средства сертификата можно использовать в качестве первоначального взноса или направить на
          погашение уже существующего ипотечного кредита.
        </ArticleParagraph2>
      ),
    },
    {
      title: 'Социальные выплаты для молодых семей',
      content: (
        <>
          <div className={styles['mb16']}>
            <ArticleParagraph2>
              Молодые семьи могут получить социальную выплату для приобретения жилья или погашения ипотечного кредита.
            </ArticleParagraph2>
          </div>

          <div className={styles['mb16']}>
            <ArticleParagraph2>
              Принять участие в программе могут семьи, в которых оба супруга моложе 36, а также одинокие родители до 35
              лет включительно с несовершеннолетними детьми. Семья должна быть признана нуждающейся в улучшении жилищных
              условий, но при этом подтвердить достаточный доход для одобрения ипотечного кредита.
            </ArticleParagraph2>
          </div>

          <div className={styles['mb16']}>
            <ArticleParagraph2>Размер выплаты составляет 30–35% от расчетной стоимости жилья.</ArticleParagraph2>
          </div>
        </>
      ),
    },
    {
      title: 'Погашение ипотеки для многодетных семей',
      content: (
        <>
          <ArticleParagraph2>
            Семьи с тремя и более детьми могут получить средства для погашения ипотеки, взятой ранее.
          </ArticleParagraph2>
          <ArticleParagraph2>
            По условиям программы третий или последующий ребёнок должен быть рожден в период с 1 января 2019 года по 31
            декабря 2030 года. А ипотечный договор — оформлен до 1 июля 2031 года на новостройку, вторичное жильё или на
            строительство дома.
          </ArticleParagraph2>
          <ArticleParagraph2>Размер выплаты — до 450 000 рублей.</ArticleParagraph2>
        </>
      ),
    },
  ],
};
